import { render, staticRenderFns } from "./frontend.vue?vue&type=template&id=768da946&scoped=true"
import script from "./frontend.vue?vue&type=script&lang=js"
export * from "./frontend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768da946",
  null
  
)

export default component.exports